import { FilterSection } from '../../types'

const groupSectionsByGroupId = (sections: FilterSection[]) =>
  sections.reduce((acc: any, section: any) => {
    ;(acc[section.groupId] = acc[section.groupId] || []).push(section)
    return acc
  }, {})

export default groupSectionsByGroupId
